import * as React from "react";
import { chunk } from "lodash";
import { Grid, Typography } from "@material-ui/core";
import Caret from "../Caret/Caret";
import { styles } from "./Detail.style";

import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

type DetailsParagraphType = {
    headline: string;
    text: string;
};

type DetailsType = {
    mentions: string[];
    paragraphs: DetailsParagraphType[];
};

interface DetailsProps {
    data: DetailsType;
}

class Details extends React.Component<DetailsProps & WithStyles<typeof styles>> {

    public render() {

        const {classes, data, theme} = this.props;

        return (
            <>
            <Grid className={classes.grid} container={true} spacing={40}>
                {chunk(data.paragraphs, 2).map((column, cIndex) => (
                    <Grid className={classes.item} item={true} xs={4} key={cIndex}>
                        <Caret color={theme.palette.primary.main} variant="thick" opacity={0.48}/>
                        {column.map((paragraph, pIndex) => (
                            <div key={pIndex}>
                            <Typography className={classes.headline} variant="subheading" component="h4">{paragraph.headline}</Typography>
                            <Typography className={classes.text} component={"p"} dangerouslySetInnerHTML={{__html: paragraph.text}}/>
                            </div>
                        ))}
                    </Grid>
                ))}
            </Grid>

            {data.mentions.map((mention, mIndex) => (
                <Typography className={classes.caption} variant="caption" dangerouslySetInnerHTML={{__html: mention}} key={mIndex}/>)
            )}
            </>
        );
    }

}

export default withStyles(styles, {withTheme: true})(Details);


// WEBPACK FOOTER //
// ./src/components/Detail/Detail.tsx